import { render, staticRenderFns } from "./PoyntApplicationId.vue?vue&type=template&id=473e398e&"
import script from "./PoyntApplicationId.vue?vue&type=script&lang=ts&"
export * from "./PoyntApplicationId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports